import LoginNew from '@/components/LoginNew.vue'

function loginRouteProps (route) {
  return {
    whitelabel: route.params.whitelabel || '',
    subscriptionId: route.params.subscriptionId,
    adminToken: route.params.adminToken
  }
}

export default [
  {
    path: '/',
    name: 'Login',
    component: LoginNew,
    props: loginRouteProps
  },
  {
    path: '/:whitelabel',
    name: 'LabelLogin',
    component: LoginNew,
    props: loginRouteProps
  },
  {
    // Not "login/sso/..." - that path belongs to CakePHP's own LoginController::sso()
    // action on the shared origin, so Cake's router would handle it first and this
    // route would never be reached. Kept flat/unprefixed like createform/editform,
    // which fall through to this SPA precisely because Cake has no matching controller.
    path: '/:whitelabel/ssologin/:subscriptionId/:adminToken',
    name: 'SSOLogin',
    component: LoginNew,
    props: loginRouteProps
  },
  {
    path: '/:whitelabel/forgot-pswd',
    name: 'ForgotPassword',
    component: () => import('@/components/ForgotPassword.vue'),
    props: route => ({
      whitelabel: route.params.whitelabel
    })
  },
  {
    path: '/:whitelabel/createform',
    name: 'CreateForm',
    component: () => import('@/components/CreateSurvey.vue')
  },
  {
    path: '/:whitelabel/editform/:id',
    name: 'EditForm',
    component: () => import('@/components/EditSurvey.vue')
  },
  {
    path: '/:whitelabel/error',
    name: 'ErrorPage',
    component: () => import('@/components/ErrorPage.vue')
  },
  {
    path: '/:whitelabel/createform/:id',
    name: 'Dashboard',
    component: () => import('@/components/Dashboard/Main.vue'),
    props: true
  },
  {
    path: '/:whitelabel/editForms/:id',
    name: 'EditDashboard',
    component: () => import('@/components/Dashboard/Main.vue'),
    props: true
  },
  {
    path: '/:whitelabel/previewform/:id',
    name: 'PreviewForm',
    component: () => import('@/components/Preview/Main.vue'),
    props: true
  },
  {
    path: '/:whitelabel/responseform/:id',
    name: 'ResponseForm',
    component: () => import('@/components/Preview/Main.vue'),
    props: true
  },
  {
    path: '/:whitelabel/editresponseform/:sid/:rid',
    name: 'EditResponseForm',
    component: () => import('@/components/EditResponse/Main.vue'),
    props: true
  },
  {
    path: '/:whitelabel/searchresponseform/:sid',
    name: 'SearchResponseForm',
    component: () => import('@/components/SearchResponse/Main.vue'),
    props: true
  }
]
